import React from 'react';
import styles from './PricingHesitant.module.scss';
import ContactConstant from '../../../utils/Constant/ContactConstant';

const formatPrice = (v) => new Intl.NumberFormat('en-US').format(v);

const PricingHesitant = ({ price = 1050000, currency = 'VND', onCtaClick }) => {
    return (
        <section className={styles.section}>
            <h2 className={styles.heading}>Still hesitant? We get it.</h2>
            <p className={styles.subtitle}>
                14-day money-back guarantee. No questions asked.<br />
                If Prepal isn't right for you, you get every cent back.
            </p>
            <div className={styles.btnRow}>
                <button className={styles.ctaBtn} onClick={onCtaClick}>
                    Start Practicing — {formatPrice(price)} {currency}
                </button>
                <a
                    href={`mailto:${ContactConstant.INFO_EMAIL}`}
                    className={styles.talkBtn}
                >
                    Talk to Us
                </a>
            </div>
        </section>
    );
};

export default PricingHesitant;
